import { render } from "./Profile.vue?vue&type=template&id=34976023"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "@/components/loading/loading.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__